import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d48f378e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overlay"
}

import { ref, watch } from "vue";
import ModalCrearTorneo from "./ModalCrearTorneo.vue";
import { useAuth } from "@/composables/useAuth";
import ModalSuccess from "../Commons/ModalSuccess.vue";
import ModalError from "../Commons/ModalError.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CardGestionTorneos',
  setup(__props) {

const { getidUsuario } = useAuth();
const idUsuarioLogger = ref<string | null>(getidUsuario.value);

const showModalCreateTournament = ref<boolean>(false);
const showErrorModal = ref<boolean>(false);
const showSuccessModal = ref<boolean>(false);
const isLoading = ref(false);

const handlerCrearTorneo = () => {
  showModalCreateTournament.value = true;
};
const closeConfigModal = () => {
  showModalCreateTournament.value = false;
};

const handleConfigConfirm = () => {
  closeConfigModal();
};

// Watch para detectar cuando se cierra el modal de éxito
watch(
  () => showSuccessModal.value,
  (newValue, oldValue) => {
    if (oldValue && !newValue) {
      recargarPagina();
    }
  }
);

const recargarPagina = () => {
  window.location.reload();
};

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, { justify: "center" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          md: "6"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, {
                      justify: "center",
                      class: "my-4 ga-5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_btn, {
                          color: "blue darken-1",
                          variant: "tonal",
                          size: "large",
                          class: "login-form__button",
                          onClick: handlerCrearTorneo
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Crear torneo ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (isLoading.value)
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          justify: "center",
                          class: "mt-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_progress_linear, {
                              size: 24,
                              width: 2,
                              indeterminate: "",
                              color: "blue darken-1",
                              class: "progress-linear-margin"
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(ModalCrearTorneo, {
      isVisible: showModalCreateTournament.value,
      idUsuario: parseInt(idUsuarioLogger.value!),
      onClose: closeConfigModal,
      onConfirm: handleConfigConfirm
    }, null, 8, ["isVisible", "idUsuario"]),
    _createVNode(ModalSuccess, {
      isVisible: showSuccessModal.value,
      message: "Torneo creado correctamente.",
      "onUpdate:isVisible": _cache[0] || (_cache[0] = ($event: any) => (showSuccessModal.value = $event))
    }, null, 8, ["isVisible"]),
    _createVNode(ModalError, {
      isVisible: showErrorModal.value,
      message: "No se crear el torneo. Intentalo de nuevo y si el error persiste contacta con el administrador.",
      "onUpdate:isVisible": _cache[1] || (_cache[1] = ($event: any) => (showErrorModal.value = $event))
    }, null, 8, ["isVisible"])
  ], 64))
}
}

})